module.exports = __webpack_public_path__ + "static/media/meeting-room.11e311db.png";